var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.207,
    height: 12.207,
    viewBox: "0 0 12.207 12.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search-",
    transform: "translate(61.59 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-50.09 13.5) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.75,
    cy: 3.75,
    r: 3.75,
    transform: "translate(3.5 3.5)",
    fill: "none",
    stroke: "#7e7e7e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x1: 4.5,
    y1: 4.5,
    transform: "translate(4.5 4.5) rotate(180)",
    fill: "none",
    stroke: "#7e7e7e",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.34bae2ba6437e9a1459ff4a5a4067e18.svg";
export { ForwardRef as ReactComponent };